import React, { useState, useRef, Component, useEffect } from "react";
import useStyles from "./styles";
import { Redirect, useHistory } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import * as mobilenet from "@tensorflow-models/mobilenet";

// MUI Components
import {
  Grid,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Button,
  Typography,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Badge,
  MenuItem,
  Menu,
  Collapse,
  Divider,
  Avatar,
  Tooltip,
  InputLabel,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

//importing files
import logo from "../../assets/images/logo.png";
import api from "../../Axios/api";

import { Switch as SwitchRouter, withRouter, Link } from "react-router-dom";
import { InputBase } from "@material-ui/core";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuIcon from "@material-ui/icons/Menu";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchIcon from "@material-ui/icons/Search";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import LocalMallOutlinedIcon from "@material-ui/icons/LocalMallOutlined";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ContactSupportOutlinedIcon from "@material-ui/icons/ContactSupportOutlined";
import LoyaltyOutlinedIcon from "@material-ui/icons/LoyaltyOutlined";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
import { FixedSizeList } from "react-window";
// import PropTypes from 'prop-types';

// User context
import { useUserContext, logoutUser } from "../../context/UserContext";
import { useCartContext } from "../../context/CartContext";
import { useWishlistContext } from "../../context/WishlistContext";

import io from "socket.io-client";
import { CameraAltOutlined, Chat, Label } from "@material-ui/icons";
const SERVER = "https://digimart-server.onrender.com";

const Header = () => {
  const classes = useStyles();
  const history = useHistory();
  // context
  let user = null;
  let profilePic = "";
  let name = "";
  let token = "";
  var socket = io(SERVER);
  const { store, dispatch } = useUserContext();
  if (store) {
    user = store;
  }
  if (user.data !== null) {
    token = user.data.token;
    name = user.data.name;
    if (user.data.data) profilePic = user.data.data.profilePic;
  }

  const { cartProducts } = useCartContext();
  const { wishlistProducts } = useWishlistContext();
  const [cartItemQuantity, setCartItemQuantity] = useState(0);
  const [wishlistItemQuantity, setWishlistItemQuantity] = useState(0);

  //for drop down of profile Btn
  const [anchorEl, setAnchorEl] = React.useState(null);
  //for dropdown of categories
  const [categories, setCategories] = React.useState(null);
  //for mobile menu
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  //for side drawer
  const [state, setState] = React.useState({});
  //categories Shop box display
  const [isShowCategoryBox, setIsShowCategoryBox] = React.useState(false);
  //categories Shop By Dept box display
  const [isShowCategoriesShopByDeptMenu, setIsShowCategoriesShopByDeptMenu] =
    React.useState(false);
  //for categories of shop Btn
  const [categoriesList, setCategoriesList] = React.useState([]);
  //for logging out
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  const [isShowNotificationsMenu, setIsShowNotificationsMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const notificationsAlreadyReceived = [];
  let notificationIds = [];
  const [unReadNotificationsLength, setUnReadNotificationsLength] = useState(
    notificationsAlreadyReceived.length
  );

  //for collapse on side drawer
  const [openCollapse, setOpenCollapse] = React.useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  //for searching selected actegory products in searchBar
  const [searchCategoryName, setSearchCategoryName] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [searchedQuery, setSearchedQuery] = useState([]);
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };
  //for opening search by image box
  const [isModelLoading, setIsModelLoading] = useState(false);
  const [model, setModel] = useState(null);
  const [imagePredictionResults, setImagePredictionResults] = useState([]);
  const [imageURL, setImageURL] = useState(null);
  const imageRef = useRef();
  const imageInputUrlRef = useRef();
  const [openImageUploadBox, setOpenImageUploadBox] = React.useState(false);
  const handleClickOpenImageUploadBox = () => {
    setOpenImageUploadBox(true);
  };

  const handleCloseImageUploadBox = () => {
    setOpenImageUploadBox(false);
  };
  const loadModel = async () => {
    setIsModelLoading(true);
    try {
      const model = await mobilenet.load();
      setModel(model);
      setIsModelLoading(false);
    } catch (e) {
      console.log("error in image detection", e);
      setIsModelLoading(false);
    }
  };

  const uploadImage = (e) => {
    const { files } = e.target;
    if (files.length > 0) {
      const url = URL.createObjectURL(files[0]);
      setImageURL(url);
    } else {
      setImageURL(null);
    }
  };

  const identifyImage = async () => {
    setImageURL(null);
    const results = await model.classify(imageRef.current);
    setImagePredictionResults(results);
    console.log("image results", results);
    const predictictedProductsNames = [];
    //pushing all results in array bcz they are in form:
    // [{
    //   className:"coat, shirt",
    //   probability:1.233
    // }]
    results.forEach((item) => {
      let classNames = item.className.split(",");
      classNames.forEach((className) => {
        predictictedProductsNames.push(className);
      });
    });
    //search all image results from matching products in DB and
    // return if got any else iterate through all results ang get result with most products
    let mostResultsPredictedName =
      predictictedProductsNames.length > 0 ? predictictedProductsNames[0] : "";
    let maxFoundProducts = 0;
    predictictedProductsNames.forEach((name) => {
      api
        .get(`/buyer/products/search?name=${name}`, {}, { Headers: {} })
        .then((res) => {
          // console.log('results', res.data.data.products)
          const products = res.data.data.products;
          if (products.length > maxFoundProducts) {
            maxFoundProducts = products.length;
            mostResultsPredictedName = name;
          }
        })
        .catch((error) =>
          console.log("error in getting data of search", error)
        );
    });

    //go to products page with maxResultsMatchedName
    history.push(
      `/products?mainCategoryName=All Categories&searchQuery=${encodeURIComponent(
        mostResultsPredictedName
      )}`
    );
    handleCloseImageUploadBox();
  };

  const handleOnChangeURLText = (e) => {
    setImageURL(e.target.value);
    setImagePredictionResults([]);
  };

  useEffect(() => {
    //loading model of tensor flow for image searching
    loadModel();

    api
      .get(`/buyer/product/categories/all`, {}, { Headers: {} })
      .then((res) => {
        setCategoriesList(res.data.data.categories);
      })
      .catch((error) =>
        console.log("error in getting data of homepage", error)
      );

    //get All my notifications

    if (user.data) {
      api
        .get("/buyer/myNotifications", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(function (res) {
          // console.log("my notifications", res.data.data.myNotifications);
          setNotifications((prevState) => [
            ...prevState,
            ...res.data.data.myNotifications,
          ]);
        })
        .catch((error) => {
          console.log("error in getting data of notifications", error);
        });
    }
  }, []);

  //for notifications
  useEffect(() => {
    const currentUser = user.data ? user.data.data : null;
    if (currentUser) {
      //setting notification if for the buyer
      socket.on("new notification", (data) => {
        if (data) {
          if (data.buyerIds.includes(currentUser._id)) {
            for (const item of notificationsAlreadyReceived) {
              notificationIds.push(item._id);
            }
            if (!notificationIds.includes(data._id)) {
              notificationsAlreadyReceived.push(data);
              setUnReadNotificationsLength(notificationsAlreadyReceived.length);
              setNotifications((prevState) => [...prevState, data]);
            }
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    if (cartProducts != null && cartProducts != "null") {
      let itemQuantityCount = 0;
      cartProducts.forEach((item) => {
        itemQuantityCount = itemQuantityCount + item.quantity;
      });

      setCartItemQuantity(itemQuantityCount);
    }
    if (wishlistProducts != null && wishlistProducts != "null") {
      setWishlistItemQuantity(wishlistProducts.length);
    }
  }, [cartProducts]);

  //for searching prducts in serach bar
  const handleSearchProducts = (searchedName) => {
    setSearchedQuery(searchedName);
    if (searchCategoryName === "All Stores") {
      api
        .get(`/buyer/search/store/${searchedName}`, {}, { Headers: {} })
        .then((res) => {
          // console.log('results', res.data.data.products)
          setSearchResults(res.data.data.Stores);
        })
        .catch((error) =>
          console.log("error in getting data of search", error)
        );
      return;
    }
    api
      .get(
        !searchCategoryName || searchCategoryName === "All Categories"
          ? `/buyer/products/search?name=${searchedName}`
          : `/buyer/products/search?name=${searchedName}&category=${searchCategoryName}`,
        {},
        { Headers: {} }
      )
      .then((res) => {
        // console.log('results', res.data.data.products)
        setSearchResults(res.data.data.products);
      })
      .catch((error) => console.log("error in getting data of search", error));
  };

  const getLinkOfProductsByCategory = (category) => {
    return `/products?mainCategoryName=${encodeURIComponent(category)}`;
  };

  //for handling search Btn
  const handleSearchButton = () => {
    let tempCategory = null;
    let searchedStore = null;
    if (!searchCategoryName && !searchedQuery) {
      return;
    }
    if (!searchCategoryName || searchCategoryName === "All Categories") {
      searchResults.forEach((result) => {
        if (result.name === searchedQuery) {
          tempCategory = result.category;
          // setSearchCategoryName(result.category);
        }
      });
    }

    closeAllMenus();
    // console.log('searchCategory',searchCategoryName,!searchCategoryName === "All Categories", 'tempcategry',tempCategory)

    if (searchCategoryName === "All Stores") {
      searchResults.forEach((result) => {
        if (result.name === searchedQuery) {
          searchedStore = result;
          // setSearchCategoryName(result.category);
        }
      });
      if (searchedStore) {
        return history.push(`/store?storeId=${searchedStore._id}`);
      } else {
        return setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "No Store found matching searched keyword.",
          open: true,
        });
      }
    }

    history.push(
      `/products?mainCategoryName=${encodeURIComponent(
        searchCategoryName
          ? searchCategoryName === "All Categories"
            ? tempCategory
              ? tempCategory
              : searchCategoryName
            : searchCategoryName
          : tempCategory
          ? tempCategory
          : "All Categories"
      )}&searchQuery=${encodeURIComponent(searchedQuery)}`
    );
  };

  //For opening products of selected category page
  const openProductsOfMainCategory = (category) => {
    history.push(
      `/products?mainCategoryName=${encodeURIComponent(
        category.mainCategoryName
      )}`
      // &mainCategoryId=${category._id}`
    );
    closeAllMenus();
    // return (
    //   <Link to={`#/products?mainCategoryName=${category.mainCategoryName}`} />
    // )
  };
  const openAllDealProducts = () => {
    return `/products?mainCategoryName=${"All Categories"}&productsFilter=onSale`;
  };
  //For opening products of selected sub-category page
  const openProductsOfSubCategory = (category, mainCategoryName) => {
    history.push(
      `/products?subCategoryName=${encodeURIComponent(
        category.name
      )}&mainCategoryOfSubCategory=${encodeURIComponent(mainCategoryName)}`
      // &mainCategoryId=${category._id}`
    );

    closeAllMenus();
    // return (
    //   <Link to={`#/products?subCategoryName=${category.name}`}/>
    // )
  };

  const closeAllMenus = () => {
    handleShowDeptCategoriesMenuClose();
    handleCategoriesMenuClose();
    handleShowCategoriesBoxClose();
    handleMobileMenuClose();
    handleMenuClose();
  };
  //for drop down of categories on search Bar
  const handleCategoriesMenuOpen = (event) => {
    setCategories(event.currentTarget);
  };
  const handleCategoriesMenuClose = () => {
    setCategories(null);
  };
  //for drop down of categories on Shop Nav Link
  const handleShowCategoriesBoxOpen = (event) => {
    setIsShowCategoryBox(event.currentTarget);
  };
  const handleShowCategoriesBoxClose = () => {
    setIsShowCategoryBox(null);
  };
  //for drop down of categories on Shop By Dept Btn
  const handleShowDeptCategoriesMenuOpen = (event) => {
    setIsShowCategoriesShopByDeptMenu(event.currentTarget);
  };
  const handleShowDeptCategoriesMenuClose = () => {
    setIsShowCategoriesShopByDeptMenu(null);
  };

  //for drop down of notifications
  const handleShowNotificationsMenuOpen = (event) => {
    setIsShowNotificationsMenu(event.currentTarget);
    setUnReadNotificationsLength(0);
  };
  const handleShowNotificationsMenuClose = () => {
    setIsShowNotificationsMenu(null);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const handleSearchedCatgeorySelection = (value) => {
    handleCategoriesMenuClose();
    setSearchCategoryName(value);
  };

  //for side drawer
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  //for collapse side drawer
  function handleOpenSettings() {
    setOpenCollapse(!openCollapse);
  }

  //for checking if logged in
  const checkIfLoggedInGoToLink = (link) => {
    if (user.data !== null) {
      // setAnchorEl(null)
      // handleMenuClose()
      return link;
    } else {
      return "/buyer/login";
    }
  };
  const goToLinkAndCloseDrawer = (link) => {
    history.push(link);
    setState({ ...state, ["left"]: false });
  };

  //for side drawer
  const list = () => (
    <div
      className={classes.list}
      role="presentation"
      // onClick={toggleDrawer("left", false)}
      // onKeyDown={toggleDrawer("left", false)}
    >
      <IconButton
        style={{ position: "absolute", right: 5, top: 3 }}
        onClick={toggleDrawer("left", false)}
      >
        <CancelOutlinedIcon />
      </IconButton>
      <List>
        <ListItem button onClick={() => goToLinkAndCloseDrawer("/")}>
          <ListItemIcon>
            <HomeOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={"Home"} />
        </ListItem>

        <ListItem button onClick={handleOpenSettings}>
          <ListItemIcon>
            <LocalMallOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={"Shop"} />
          {openCollapse ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        {/* Collapse List of categories */}
        <Collapse
          in={openCollapse}
          timeout="auto"
          unmountOnExit
          className={classes.collapseList}
        >
          {categoriesList.map((item) =>
            React.cloneElement(
              <List component="div" disablePadding>
                <ListItem
                  onClick={()=>goToLinkAndCloseDrawer(
                    `/products?mainCategoryName=${encodeURIComponent(
                      item.mainCategoryName
                    )}`
                  )}
                  button
                >
                  <ListItemText
                    style={{ fontWeight: "bold" }}
                    primary={item.mainCategoryName}
                  />
                </ListItem>

                {item.subCategories.map((subCategory) =>
                  React.cloneElement(
                    <ListItem
                      button
                      onClick={()=>goToLinkAndCloseDrawer(
                        `/products?subCategoryName=${encodeURIComponent(
                          subCategory.name
                        )}&mainCategoryOfSubCategory=${encodeURIComponent(
                          item.mainCategoryName
                        )}`
                      )}
                    >
                      <ListItemText secondary={subCategory.name} />
                    </ListItem>,
                    {
                      key: subCategory._id,
                    }
                  )
                )}
                <Divider
                  style={{
                    backgroundColor: "#e1e1e1",
                    height: "0.5px",

                    marginTop: 16,
                    marginBottom: 16,
                  }}
                />
              </List>,

              {
                key: item.mainCategory,
              }
            )
          )}
        </Collapse>

        <ListItem
          onClick={()=>goToLinkAndCloseDrawer(
            `/products?mainCategoryName=${"All Categories"}&productsFilter=onSale`
          )}
          button
        >
          <ListItemIcon>
            <LoyaltyOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={"Deals"} />
        </ListItem>

        <ListItem button onClick={()=>goToLinkAndCloseDrawer('/aboutus')}>
          <ListItemIcon>
            <InfoOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={"About us"}
          />
        </ListItem>

        <ListItem button onClick={() => goToLinkAndCloseDrawer('/contact')}>
          <ListItemIcon>
            <ContactSupportOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={"Contact"}
          />
        </ListItem>
      </List>
    </div>
  );

  //for opening login page
  const openLoginPage = () => {
    history.push("/buyer/login");
  };

  // Logout
  const logoutHandler = (e) => {
    // e.preventDefault();
    if (user.data === null) {
      return;
    }
    api
      .post(
        "/buyer/logout",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(function (res) {
        console.log("logging off");
        setIsLoggedOut(true);
        localStorage.removeItem("CART_DATA");
        localStorage.removeItem("WISHLIST_DATA");
        window.location.href = `/buyer/login`;
        return logoutUser(dispatch);
      })
      .catch((error) => {
        window.location.href = "/buyer/login";
        console.log("ERROR: " + JSON.stringify(error.response.data.error));
      });
  };

  const menuId = "primary-search-account-menu";
  //render profile button menu
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {!token ? (
        <MenuItem onClick={() => openLoginPage()}>Login</MenuItem>
      ) : null}
      <Link
        style={{ textDecoration: "none", color: "black" }}
        to={() => checkIfLoggedInGoToLink("/account")}
      >
        <MenuItem>My Account</MenuItem>
      </Link>
      <Link style={{ textDecoration: "none", color: "black" }} to="/wishlist">
        <MenuItem>
          WishList
          <span
            style={{
              borderRadius: "100%",
              backgroundColor: "red",
              color: "white",
              paddingLeft: 7,
              paddingRight: 7,
              marginLeft: 8,
              fontSize: 12,
            }}
          >
            {wishlistItemQuantity}
          </span>
        </MenuItem>
      </Link>
      <Link
        style={{ textDecoration: "none", color: "black" }}
        to={checkIfLoggedInGoToLink("/buyer/messages")}
      >
        <MenuItem>Messages</MenuItem>
      </Link>

      {token ? (
        <MenuItem onClick={(e) => logoutHandler(e)}>Logout</MenuItem>
      ) : // (window.location.href = "/login")
      null}
    </Menu>
  );

  //for rendering mobile menu drop down
  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* Notifications Btn */}
      <Button
        className={classes.customIconButton}
        aria-label="show 2 new notifications"
        color="inherit"
        style={{ backgroundColor: "#fff" }}
        onClick={handleShowNotificationsMenuOpen}
        style={{ textTransform: "none", padding: 0 }}
      >
        <Typography style={{ marginLeft: 7 }}>Notifications</Typography>
        {unReadNotificationsLength > 0 ? (
          <span className={classes.badge}>{unReadNotificationsLength}</span>
        ) : null}
      </Button>
      <Link
        style={{ textDecoration: "none", color: "black" }}
        to={checkIfLoggedInGoToLink("/buyer/messages")}
      >
        <MenuItem>Messages</MenuItem>
      </Link>

      {/* WishList Btn */}
      <Link
        style={{ textDecoration: "none", color: "black" }}
        to={"/wishlist"}
        aria-label="show 2 new notifications"
        color="inherit"
      >
        <MenuItem>Wishlist</MenuItem>
      </Link>

      {!token ? (
        <MenuItem onClick={() => openLoginPage()}>Login</MenuItem>
      ) : null}
      <Link
        style={{ textDecoration: "none", color: "black" }}
        to={() => checkIfLoggedInGoToLink("/account")}
      >
        <MenuItem>My Account</MenuItem>
      </Link>
      {token ? (
        <MenuItem onClick={(e) => logoutHandler(e)}>Logout</MenuItem>
      ) : // (window.location.href = "/login")
      null}
    </Menu>
  );

  const goToRouteOfNotification = (type) => {
    if (type === "order") {
      history.push(`/orders`);
    }
  };

  return (
    <div>
      {isLoggedOut ? openLoginPage() : ""}

      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
      <div className={classes.header}>
        <AppBar position="sticky" className={classes.appBar}>
          <Toolbar className={classes.appBarToolBar}>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer("left", true)}
              // className={classes.sectionMobile}
            >
              <MenuIcon />
            </IconButton>
            <Link to="/">
              <img src={logo} alt="Logo" className={classes.logo} />
            </Link>
            {/* SEARCH BAR */}
            <div className={classes.searchBar}>
              {/* Dropdown of categories */}
              <div>
                <Button
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleCategoriesMenuOpen}
                  className={classes.categoriesDropBtn}
                  noWrap
                >
                  <ExpandMoreIcon />
                  <Typography variant="h6" noWrap style={{ width: 130 }}>
                    {searchCategoryName ? searchCategoryName : "All Categories"}
                  </Typography>
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={categories}
                  keepMounted
                  open={Boolean(categories)}
                  onClose={handleCategoriesMenuClose}
                  className={classes.menuCategoiesSearchBar}
                >
                  <MenuItem
                    onClick={() =>
                      handleSearchedCatgeorySelection("All Categories")
                    }
                    noWrap
                  >
                    All Categories
                  </MenuItem>
                  <MenuItem
                    onClick={() =>
                      handleSearchedCatgeorySelection("All Stores")
                    }
                    noWrap
                  >
                    All Stores
                  </MenuItem>
                  {categoriesList.map((item) =>
                    React.cloneElement(
                      <MenuItem
                        onClick={() =>
                          handleSearchedCatgeorySelection(item.mainCategoryName)
                        }
                        noWrap
                      >
                        {item.mainCategoryName}
                      </MenuItem>,
                      {
                        key: item._id,
                      }
                    )
                  )}
                </Menu>
              </div>

              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <Autocomplete
                  id="combo-box-demo"
                  options={searchResults}
                  freeSolo
                  onChange={(event, value) =>
                    value
                      ? value.name
                        ? setSearchedQuery(value.name)
                        : null
                      : null
                  }
                  getOptionLabel={(option) => option.name}
                  style={{ width: 280 }}
                  renderInput={(params) => {
                    const { InputLabelProps, InputProps, ...rest } = params;
                    return (
                      <InputBase
                        {...params.InputProps}
                        {...rest}
                        placeholder="Search Here…"
                        classes={{
                          root: classes.inputRoot,
                          input: classes.inputInput,
                        }}
                        onChange={(e) => handleSearchProducts(e.target.value)}
                      />
                    );
                  }}
                />
                <Tooltip title="Search By Image" aria-label="Search By Image">
                  <Badge
                    color="primary"
                    badgeContent={"New"}
                    style={{ marginRight: 15 }}
                  >
                    <IconButton
                      onClick={handleClickOpenImageUploadBox}
                      color="secondary"
                      style={{ padding: 0, backgroundColor: "transparent" }}
                    >
                      <CameraAltOutlined />
                    </IconButton>
                  </Badge>
                </Tooltip>
              </div>
              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleSearchButton}
                className={classes.searchBtn}
              >
                <Typography variant="h6">Search</Typography>
              </Button>
            </div>

            <div className={classes.grow} />
            {/* Cart  Btn*/}
            <IconButton
              // onClick={() => (window.location.href = "/cart")}
              style={{ color: "black", backgroundColor: "#fff" }}
              className={classes.customIconButton}
              aria-label="show 4 new prodcuts"
              color="inherit"
            >
              <Link to="/cart" style={{ color: "black" }}>
                <Badge badgeContent={cartItemQuantity} color="primary">
                  <ShoppingCartIcon />
                </Badge>
              </Link>
            </IconButton>
            <div className={classes.sectionDesktop}>
              {/* Notifications Btn */}
              <IconButton
                className={classes.customIconButton}
                aria-label="show 2 new notifications"
                color="inherit"
                style={{ backgroundColor: "#fff" }}
                onClick={handleShowNotificationsMenuOpen}
              >
                  <Badge
                    badgeContent={unReadNotificationsLength}
                    color="primary"
                  >
                    <NotificationsIcon style={{marginTop:2}} />
                  </Badge>
              </IconButton>

              {/* ................SHOW NOTIFICATIONS BOX................. */}
              <Menu
                id="notifications-box"
                anchorEl={isShowNotificationsMenu}
                //keepMounted
                className={classes.notificationMenu}
                open={Boolean(isShowNotificationsMenu)}
                onClose={handleShowNotificationsMenuClose}
              >
                <Typography
                  variant="h6"
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    padding: 10,
                  }}
                >
                  Notifications
                </Typography>
                <Typography
                  style={{
                    color: "grey",
                    padding: 4,
                    borderBottom: "0.1px solid #e5e5e5",
                  }}
                >
                  {notifications.length < 1 ? "Notifications are empty." : null}
                </Typography>
                {notifications.map((item) =>
                  React.cloneElement(
                    <div
                      className={classes.notificationItemBox}
                      onClick={() => goToRouteOfNotification(item.type)}
                    >
                      <MenuItem
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          borderBottom: "0.2px solid #e5e5e5",
                          textAlign: "justify",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <AddAlertIcon color="primary" />
                          <Typography
                            className={classes.HeaderLinksHeadingText}
                            variant="p"
                            style={{ color: "#666", fontSize: 15 }}
                          >
                            {item.message}
                          </Typography>
                        </div>
                        <Typography
                          style={{
                            marginTop: 3,
                            fontSize: 13,
                            color: "black",
                            fontStyle: "italic",
                          }}
                        >
                          {item.createdAt.split("T")[0]},{" "}
                          {item.createdAt.split("T")[1].split(":")[0]}:
                          {item.createdAt.split("T")[1].split(":")[1]}
                        </Typography>
                      </MenuItem>
                    </div>,
                    {
                      key: item.mainCategory,
                    }
                  )
                )}
              </Menu>

              {/* Profile Btn */}
              <IconButton
                edge="end"
                className={classes.customIconButton}
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <Avatar alt="Remy Sharp" src={profilePic} />
              </IconButton>
            </div>
            {/* For mobile section */}
            <div className={classes.sectionMobile}>
              <IconButton
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
                className={classes.moreIconForMobile}
              >
                <Avatar style={{height:30, width:30, objectFit:'fill', padding:0}} alt="Remy Sharp" src={profilePic} />
              </IconButton>
            </div>
          </Toolbar>
          {/* PAGES NAVIGATION BAR */}

          {/* SEARCH BAR FOR MOBILE */}
          <div className={classes.searchBarMobile}>
            {/* Dropdown of categories */}
            <div className={classes.search}>
              {/* Dropdown of categories */}
              <div
                style={{
                  borderRight: "1px solid #e5e5e5",
                  display: "flex",
                  height: "100%",
                }}
              >
                <Button
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleCategoriesMenuOpen}
                  className={classes.categoriesDropBtnMobile}
                  style={{ padding: 0 }}
                  noWrap
                >
                  <ExpandMoreIcon
                    style={{
                      paddingRight: 0,
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  />
                  <Typography variant="h6" noWrap style={{ fontSize: 14 }}>
                    {searchCategoryName ? searchCategoryName : ""}
                  </Typography>
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={categories}
                  keepMounted
                  open={Boolean(categories)}
                  onClose={handleCategoriesMenuClose}
                  className={classes.menuCategoiesSearchBar}
                >
                  <MenuItem
                    onClick={() =>
                      handleSearchedCatgeorySelection("All Categories")
                    }
                    noWrap
                  >
                    All Categories
                  </MenuItem>
                  <MenuItem
                    onClick={() =>
                      handleSearchedCatgeorySelection("All Stores")
                    }
                    noWrap
                  >
                    All Stores
                  </MenuItem>
                  {categoriesList.map((item) =>
                    React.cloneElement(
                      <MenuItem
                        onClick={() =>
                          handleSearchedCatgeorySelection(item.mainCategoryName)
                        }
                        noWrap
                      >
                        {item.mainCategoryName}
                      </MenuItem>,
                      {
                        key: item._id,
                      }
                    )
                  )}
                </Menu>
              </div>
              <div className={classes.searchIconMobile}>
                <SearchIcon />
              </div>
              <Autocomplete
                id="combo-box-demo"
                options={searchResults}
                freeSolo
                fullWidth
                onChange={(event, value) =>
                  value
                    ? value.name
                      ? setSearchedQuery(value.name)
                      : null
                    : null
                }
                getOptionLabel={(option) => option.name}
                // style={{ minWidth: 270 }}
                renderInput={(params) => {
                  const { InputLabelProps, InputProps, ...rest } = params;
                  return (
                    <InputBase
                      {...params.InputProps}
                      {...rest}
                      placeholder="Search Here…"
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputInputMobile,
                      }}
                      onChange={(e) => handleSearchProducts(e.target.value)}
                    />
                  );
                }}
              />
              <Tooltip title="Search By Image" aria-label="Search By Image">
                <Badge
                  color="primary"
                  badgeContent={"New"}
                  style={{ marginRight: 15 }}
                >
                  <IconButton
                    onClick={handleClickOpenImageUploadBox}
                    color="secondary"
                    style={{ padding: 0, backgroundColor: "transparent" }}
                  >
                    <CameraAltOutlined />
                  </IconButton>
                </Badge>
              </Tooltip>
            </div>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleSearchButton}
              className={classes.searchBtn}
            >
              Search
            </Button>
          </div>

          <Grid className={classes.navigationBar}>
            <Button
              aria-controls="simple-menu-Dept-categories-Btn"
              anchorEl={isShowCategoriesShopByDeptMenu}
              aria-haspopup="true"
              onClick={handleShowDeptCategoriesMenuOpen}
              className={classes.shopByDepartmentBtn}
            >
              <MenuIcon style={{ marginRight: 21 }} />
              <Typography variant="h5" className={classes.shopDeptText}>
                Shop By Categories
              </Typography>
              <ExpandMoreIcon className={classes.expandMoreBtnShopByDept} />
            </Button>

            {/* ................SHOP DEPT CATEGORIES DROPDOWN MENU BOX................. */}
            <Menu
              id="simple-menu-Dept-categories-Btn"
              anchorEl={isShowCategoriesShopByDeptMenu}
              //keepMounted
              className={classes.shopByDeptMenu}
              open={Boolean(isShowCategoriesShopByDeptMenu)}
              onClose={handleShowDeptCategoriesMenuClose}
            >
              {categoriesList.map((item) =>
                React.cloneElement(
                  <div
                    style={{
                      width: 314,
                    }}
                  >
                    <div>
                      <MenuItem
                        onClick={() => openProductsOfMainCategory(item)}
                      >
                        <Typography
                          className={classes.HeaderLinksHeadingText}
                          variant="h6"
                          style={{ fontWeight: "bold" }}
                        >
                          {item.mainCategoryName}
                        </Typography>
                      </MenuItem>

                      {item.subCategories.map((subCategory) =>
                        React.cloneElement(
                          <MenuItem
                            style={{ color: "grey", paddingLeft: 30 }}
                            onClick={() =>
                              openProductsOfSubCategory(
                                subCategory,
                                item.mainCategoryName
                              )
                            }
                          >
                            {subCategory.name}
                          </MenuItem>,
                          {
                            key: subCategory._id,
                          }
                        )
                      )}
                    </div>
                    <Divider
                      style={{
                        backgroundColor: "#e1e1e1",
                        height: "0.5px",
                        marginLeft: 30,
                        marginRight: 30,
                        marginTop: 17,
                        marginBottom: 10,
                      }}
                    />
                  </div>,
                  {
                    key: item.mainCategory,
                  }
                )
              )}
            </Menu>

            <Typography variant="h6" className={classes.NavLinksBox}>
              <Button className={classes.navLinkBtn}>
                <Link to="/" className={classes.navLinkText}>
                  Home
                </Link>
              </Button>
              <Button
                className={classes.navLinkBtn}
                aria-controls="simple-menu-categories-box"
                aria-haspopup="true"
                onClick={handleShowCategoriesBoxOpen}
              >
                <Typography
                  className={classes.navLinkText}
                  style={{ display: "flex", padding: 2 }}
                  onClick={handleShowCategoriesBoxOpen}
                >
                  Shop
                </Typography>
                <ExpandMoreIcon style={{ marginLeft: 5 }} />
              </Button>

              {/* ................SHOP CATEGORIES DROPDOWN MENU BOX................. */}
              <Menu
                id="simple-menu-categories-box"
                anchorEl={isShowCategoryBox}
                //keepMounted
                className={classes.shopCategoriesDropDown}
                open={Boolean(isShowCategoryBox)}
                onClose={handleShowCategoriesBoxClose}
              >
                {categoriesList.map((item) =>
                  React.cloneElement(
                    <div
                      style={{
                        width: "560px",
                        paddingLeft: 10,
                        paddingRight: 10,
                      }}
                    >
                      <div
                        style={{
                          width: "270px",
                          float: "left",
                          paddingBottom: 15,
                        }}
                      >
                        <Typography
                          className={classes.HeaderLinksHeadingText}
                          variant="h6"
                          style={{ fontWeight: "bold", marginTop: 10 }}
                        >
                          {item.mainCategoryName}
                        </Typography>

                        {item.subCategories.map((subCategory) =>
                          React.cloneElement(
                            <MenuItem
                              style={{ color: "grey" }}
                              onClick={() =>
                                openProductsOfSubCategory(
                                  subCategory,
                                  item.mainCategoryName
                                )
                              }
                            >
                              {subCategory.name}
                            </MenuItem>,
                            {
                              key: subCategory._id,
                            }
                          )
                        )}
                      </div>
                    </div>,
                    {
                      key: item.mainCategory,
                    }
                  )
                )}
                {/* <Grid lg={3}></Grid>
                  <Grid lg={3}></Grid> */}
              </Menu>

              <Button className={classes.navLinkBtn}>
                <Link to={openAllDealProducts} className={classes.navLinkText}>
                  Deals
                </Link>
              </Button>
              <Button className={classes.navLinkBtn}>
                <Link to="/aboutus" className={classes.navLinkText}>
                  About us
                </Link>
              </Button>
              <Button className={classes.navLinkBtn}>
                <Link to="/contact" className={classes.navLinkText}>
                  Contact
                </Link>
              </Button>
            </Typography>
          </Grid>
        </AppBar>

        {/* SIDE NAVIGATION DRAWER FOR MOBILE AND TAB VIEW */}
        <Drawer
          anchor={"left"}
          open={state["left"]}
          onClose={toggleDrawer("left", false)}
        >
          {list("left")}
        </Drawer>

        {/*For switching btw mobile And Desktop view*/}
        {renderMobileMenu}
        {renderMenu}
      </div>
      {/* Image Uplaod Dialog Box */}
      <div>
        <Dialog
          open={openImageUploadBox}
          onClose={handleCloseImageUploadBox}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Search By Image</DialogTitle>
          <DialogContent
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <DialogContentText>
              Please upload image of object you want to search for or paste
              image URL below.
            </DialogContentText>
            <input
              type="file"
              accept="image/*"
              capture="camera"
              className="uploadInput"
              onChange={uploadImage}
            />
            <Typography style={{ marginTop: 21, fontWeight: "bold" }}>
              OR
            </Typography>
            <TextField
              autoFocus
              style={{ padding: 0, margin: 0 }}
              id="imageURLText"
              label="Image URL"
              type="text"
              fullWidth
              ref={imageInputUrlRef}
              onChange={handleOnChangeURLText}
              // onChange={(e) => setAccountPassword(e.target.value)}
            />
            {imageURL ? (
              <img
                style={{
                  maxWidth: "150px",
                  maxHeight: "150px",
                  objectFit: "cover",
                  margin: 15,
                  marginLeft: 2,
                }}
                src={imageURL}
                alt="Upload Preview"
                crossOrigin="anonymous"
                ref={imageRef}
              />
            ) : null}
          </DialogContent>
          <DialogActions style={{ margin: 10 }}>
            <Button
              onClick={handleCloseImageUploadBox}
              variant="outlined"
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => identifyImage()}
              color="primary"
              variant="contained"
            >
              <SearchIcon />
              Search
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default withRouter(Header);
